module.exports = __webpack_public_path__ + "static/media/Quicksand-Light.ec11e4d8.woff2";